var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "10px",
    viewBox: "0 0 26 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Undo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workspace---Scan-List",
    transform: "translate(-327.000000, -123.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.625,123 C327.465,123 327.30498,123.06123 327.183105,123.183105 C327.060605,123.304355 327,123.465 327,123.625 L327,131.75 C327,132.440356 327.559644,133 328.25,133 L336.375,133 C336.535,133 336.694394,132.938145 336.816894,132.816895 C337.060645,132.573145 337.060645,132.176855 336.816894,131.933105 L333.525879,128.64209 C335.28535,127.081869 337.587579,126.125 340.125,126.125 C344.06125,126.125 347.459844,128.403437 349.089844,131.710938 C349.434844,132.410937 350.235801,132.754336 350.977051,132.506836 C351.863301,132.211836 352.313594,131.19959 351.902344,130.36084 C349.769844,126.00459 345.30375,123 340.125,123 C336.724369,123 333.646962,124.312892 331.321289,126.4375 L328.066894,123.183105 C327.945019,123.06123 327.785,123 327.625,123 Z",
    id: "Undo"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.9680e8f029b71d7e1dfe9c788a702296.svg";
export { ForwardRef as ReactComponent };